export class SimplifiedRosterFileHistory {
  id = 0;

  name = '';

  constructor(obj: any) {
    Object.assign(this, obj);
  }
}
